import { SubAreaContent } from "../contentManager/SubAreaContent";

export const PracticalContentPersonal = () => {
    return <div className="practical-container">
        <h2>1. Praxisraum</h2>
        <SubAreaContent isProjectSpecific={false} isUserSpecific={true} notes={true} area="practicalRoom" />
    </div>;
};